<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option>{{ overrideEmptyOption !== '' ? overrideEmptyOption : '' }}</lcs-option>
      } @for (schedule of schedules | async; track trackBy(schedule)) {
      <lcs-option [value]="schedule" id="lcs-option-id-{{ schedule.scheduleId }}">
         {{ schedule.name }}
      </lcs-option>
      }
   </div>
</ng-template>
